import { render, staticRenderFns } from "./VersionDialog.vue?vue&type=template&id=036dbeff&scoped=true"
import script from "./VersionDialog.vue?vue&type=script&lang=js"
export * from "./VersionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036dbeff",
  null
  
)

export default component.exports